export default function About() {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-gray-900 rounded-3xl p-12 md:p-16 relative overflow-hidden">
          <div className="absolute top-8 left-8 text-teal-400/20 text-8xl font-serif">"</div>
          
          <div className="relative z-10">
            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <h2 className="text-4xl font-bold text-white mb-6">
                  About STRADE SRL
                </h2>
                <p className="text-gray-300 leading-relaxed mb-6">
                  STRADE SRL is a leading technology company dedicated to protecting 
                  digital privacy and security. Based in Bari, Italy, we specialize 
                  in developing cutting-edge VPN solutions that empower users to 
                  browse the internet freely and securely.
                </p>
                <p className="text-gray-300 leading-relaxed">
                  Our mission is to make online privacy accessible to everyone. We 
                  believe that internet freedom is a fundamental right, and we're 
                  committed to providing the tools necessary to protect that right 
                  in an increasingly connected world.
                </p>
              </div>

              <div>
                <p className="text-gray-300 leading-relaxed mb-6">
                  With years of expertise in cybersecurity and network technology, 
                  our team has built a VPN service that combines robust security 
                  features with user-friendly design. We continuously innovate to 
                  stay ahead of emerging threats and ensure our users always have 
                  the best protection available.
                </p>
                <p className="text-gray-300 leading-relaxed">
                  At STRADE SRL, we take a user-centric approach to everything we do. 
                  From our strict no-logs policy to our responsive customer support, 
                  every decision is made with your privacy and satisfaction in mind. 
                  Join thousands of users who trust STRADE VPN to keep their online 
                  activities private and secure.
                </p>
              </div>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-700">
              <div className="flex items-center gap-2 text-gray-400">
                <i className="ri-map-pin-line"></i>
                <span>VIA ALESSANDRO MARIA CALEFATI 42, 70121 BARI, Italy</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
